import React from "react";

interface ButtonProps {
  text?: string;
  icon?: React.ReactNode;
  iconPosition?: "left" | "right";
  variant?: "primary" | "secondary" | "outline" | "transparent";
  size?: "small" | "medium" | "large";
  onClick?: () => void;
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  text,
  icon,
  iconPosition = "left",
  variant = "primary",
  size = "large",
  onClick,
  className = "",
  type = "button",
  disabled = false,
}) => {
  const hasText = !!text;
  const hasIcon = !!icon;
  const onlyIcon = hasIcon && !hasText;

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`btn ${variant} ${size} ${
        onlyIcon ? "icon-only" : ""
      } ${className}`}
    >
      {hasIcon && iconPosition === "left" && (
        <span className="btn-icon">{icon}</span>
      )}
      {hasText && <span className="btn-text">{text}</span>}
      {hasIcon && iconPosition === "right" && (
        <span className="btn-icon">{icon}</span>
      )}
    </button>
  );
};
export default Button;
